<template>
    <v-container class="d-flex justify-space-between mb-6" fluid>
        <v-overlay :value="loading">
            <div v-if="loading" class="text-center">
                <v-progress-circular
                    color="primary"
                    indeterminate
                ></v-progress-circular>
            </div>
        </v-overlay>
        <v-row v-if="!loading">
            <v-col v-for="doc in docs" v-bind:key="doc" cols="6">
                <v-card
                    elevation="2"
                >
                    <v-card-title>{{ doc.name }}</v-card-title>
                    <v-card-subtitle>{{ doc.date }}</v-card-subtitle>
                    <v-card-actions>
                        <v-btn
                            outlined
                            rounded
                            text
                            @click="download(doc.name)"
                        >Herunterladen
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col cols="6">
                <v-card
                    elevation="2"
                >
                    <v-card-title>Klassenlisten</v-card-title>
                    <v-autocomplete
                        v-model="selectedClass"
                        :items="classes"
                        :return-object="true"
                        class="ml-4"
                        clearable
                        item-text="full_name"
                        item-value="IDFaecher"
                        label="Klasse"
                        no-data-text="Loading..."
                        prepend-inner-icon="mdi-magnify"
                        style="max-width: 260px"
                    />
                    <v-card-actions>
                        <v-btn
                            outlined
                            rounded
                            text
                            @click="classList"
                        >Herunterladen
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">

import {Component, Vue} from "vue-property-decorator";
import {useHttp} from '@/core/http'
import swal from "sweetalert";

@Component
export default class Documents extends Vue {
    private docs: any = null
    private classes: Array<any> = []
    private selectedClass: Record<string, any> = {}
    private http = useHttp()
    private loading: boolean = false;

    public async download(name: string) {
        try {
            const data = await this.http.get(`file/dkb/${name}`)
            if (data) {
                const link = document.createElement('a')
                link.href = data
                link.setAttribute('download', name)
                document.body.appendChild(link)
                link.click()
            }
        } catch (error) {
            console.log(error)
        }
    }

    private async mounted() {
        // get data for classes and subjects
        this.loading = true

        this.docs = await this.http.get(`file/dkb`)
        const data = await this.http.get('classes')
        this.classes = data.data

        this.loading = false
    }

    private async classList() {
        if (!this.selectedClass.IDArtSchule) {
            swal("Warnung", "Bitte eine Klasse auswählen.", "warning")
            return
        }
        try {
            const data = await this.http.get(`class/list/${this.selectedClass.IDArtSchule}`)
            if (data) {
                const link = document.createElement('a')
                link.href = data
                link.setAttribute('download', 'class')
                document.body.appendChild(link)
                link.click()
            }
        } catch (error) {
            swal('Fehler', 'Klassenliste konnte nicht heruntergeladen werden.', 'error')
            console.log(error)
        }
    }
}

</script>

<style scoped>

</style>
